<template>
  <div>
    <div class="title status1" v-if="status == 1">
      <span class="number_new"><span class="number">1</span><span>报名信息填写</span> <span class="line"></span></span>
      <span v-if="$store.state.needExam"><span class="number" >2</span> <span>招募答题</span> <span class="line"></span></span>
      <span v-if="!$store.state.needExam"><span class="number">2</span> <span>身份证上传</span> <span class="line"></span></span>
    </div>
    <div class="title status2" v-else-if="status == 2 || status == 3 | status == 4" style="padding-left: .34rem">
      <span><span class="number">1</span><span>报名信息填写</span> <span class="line"></span></span>
      <span class="number_new"><span class="number">2</span> <span>招募答题</span> <span class="line"></span></span>
      <span><span class="number">3</span> <span>身份证上传</span> <span class="line"></span></span>
    </div>
    <div class="title status3" v-else-if="status == 5">
      <span v-if="$store.state.needExam"><span class="line line3_2"></span><span class="number">2</span> <span>招募答题</span> <span
          class="line"></span></span>
      <span v-if="!$store.state.needExam"><span class="number">1</span> <span>报名信息填写</span> <span
          class="line"></span></span>
      <span v-if="!$store.state.needExam" class="number_new"><span class="number">2</span> <span>身份证上传</span> <span class="line"></span></span>
      <span  v-if="$store.state.needExam" class="number_new"><span class="number">3</span> <span>身份证上传</span> <span class="line"></span></span>
      <span  v-if="!$store.state.needExam"><span class="number">3</span> <span>驾驶证上传</span> <span class="line"></span></span>
      <span  v-if="$store.state.needExam"><span class="number">4</span> <span>驾驶证上传</span> <span class="line"></span></span>
    </div>
    <div class="title status4" v-else-if="status == 6 || status == 7"> <!-- 后台会再加状态，待完善 -->
      <span v-if="!$store.state.needExam"><span class="line line4_3"></span><span class="number">2</span><span>身份证上传</span> <span
          class="line"></span></span>
      <span v-if="$store.state.needExam"><span class="line line4_3"></span><span class="number">3</span><span>身份证上传</span> <span
          class="line"></span></span>
      <span v-if="!$store.state.needExam" class="number_new"><span class="number">3</span> <span>驾驶证上传</span> <span class="line"></span></span>
      <span v-if="$store.state.needExam" class="number_new"><span class="number">4</span> <span>驾驶证上传</span> <span class="line"></span></span>
      <span v-if="!$store.state.needExam"><span class="number">4</span>信息审核 <span></span> <span class="line"></span></span>
      <span v-if="$store.state.needExam"><span class="number">5</span>信息审核 <span></span> <span class="line"></span></span>
    </div>
    <div class="title status5" v-else-if="status == 8 || status == 9 || status == 10 || status == 11">
      <span v-if="!$store.state.needExam"><span class="line line5_4"></span><span class="number">3</span><span>驾驶证上传</span> <span
          class="line"></span></span>
      <span v-if="$store.state.needExam"><span class="line line5_4"></span><span class="number">4</span><span>驾驶证上传</span> <span
          class="line"></span></span>
      <span v-if="!$store.state.needExam" class="number_new"><span class="number">4</span> <span>信息审核</span> <span class="line"></span></span>
      <span v-if="$store.state.needExam" class="number_new"><span class="number">5</span> <span>信息审核</span> <span class="line"></span></span>
      <span v-if="!$store.state.needExam"><span class="number">5</span> <span>预约路考</span></span>
      <span v-if="$store.state.needExam"><span class="number">6</span> <span>预约路考</span></span>
    </div>
    <div class="title status6" v-else> <!-- 状态为 12 13 -->
      <span v-if="!$store.state.needExam"><span class="line line5_4"></span><span class="number">4</span><span>信息审核</span> <span
          class="line"></span></span>
      <span v-if="$store.state.needExam"><span class="line line5_4"></span><span class="number">5</span><span>信息审核</span> <span
          class="line"></span></span>
      <span v-if="!$store.state.needExam" class="number_new"><span class="number">5</span><span>预约路考</span></span>
      <span v-if="$store.state.needExam" class="number_new"><span class="number">6</span><span>预约路考</span></span>
    </div>
  </div>
</template>

<script>
import { getSwitch } from '../utils/actions'

export default {
  data () {
    return {}
  },
  props: {
    status: String
  },
  mounted () {
    this.getSwitchInfo()
  },
  methods: {
    getSwitchInfo () {
      getSwitch({
        open_id: this.$store.state.openid,
        driver_work_type: this.$store.state.workType
      }).then((res) => {
        this.$store.commit('NEEDEXAM', res.data.exam)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  font-size: .24rem;
  // width: 100%;
  margin-top: .56rem;
  color: #97989B;
  line-height: .36rem;
  white-space: nowrap;
  overflow: hidden;
  padding-bottom: .1rem;
}

.title span {
  display: inline-block;
}

.number {
  background: #97989B;
  width: .36rem;
  height: .36rem;
  border-radius: 50%;
  display: inline-block;
  line-height: .36rem;
  color: #fff;
  font-size: .24rem;
  text-align: center;
  margin-right: .1rem;
}

.number_new {
  color: #FF5548;
}

.number_new span:first-child {
  background: #FF5548
}

.status1 {
  margin-left: 2.76rem;
}

.line {
  width: .6rem;
  line-height: .18rem;
  height: .18rem;
  border-bottom: 1px solid #979797;
  text-align: center;
  margin: 0 .05rem .09rem .05rem;
}

.line3_2 {
  width: .3rem;
}

.line4_3 {
  width: .12rem;
}

.line5_4 {
  width: .3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/StatusBar.vue